import {
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  getFormattedDateTime,
  getFormattedTime,
  isLargeScreen,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { FileUploadComponent } from '../../../../shared/components/file-upload/file-upload.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { IncidentsService } from '../incidents.service';

@Component({
  selector: 'gtapp-view-incident',
  templateUrl: './view-incident.component.html',
  styleUrl: './view-incident.component.scss',
  standalone: false,
})
export class ViewIncidentComponent implements OnInit, OnDestroy {
  largeView = isLargeScreen;
  fetchingData: Boolean = true;

  incidentHistoryTableDetails: any = [
    {
      header: 'Date',
      name: 'updated_at',
      datetimeObj: true,
      sortKey: 'updated_at',
      dateRangeKey: 'updated_at',
    },
    {
      header: 'Update By',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },

    {
      header: 'Update',
      name: 'action',
      sortKey: 'action',
      searchKey: 'action',
    },
  ];
  histChangeTableView: any = [
    {
      header: 'Date',
      name: 'updated_at',
      datetimeObj: true,
      sortKey: 'updated_at',
      dateRangeKey: 'updated_at',
    },
    {
      header: 'Update By',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },
  ];
  tableStyle = {
    'overflow': 'auto',
    'max-height': '400px',
  };
  incidentId: any;

  detailData: any;

  isAdmin: boolean = false;
  isCreatedUser: boolean = false;
  isDispatcher: boolean = false;

  isIncidentSubmitted: boolean = false;
  dialogRef: any;
  newValue: any;
  previousTextValue: any;
  subscriberUserId: any;
  userData: any;

  incidentCommentFiles: any = [];
  sortedIncidentCommentFiles: any[] = [];
  incidentHistory: any = [];

  userList: any = [];
  resolutionDay: any;
  resolutionTime: any;
  resolutionDateTime: any;

  selectedHistoryEvent: any;

  todayDate: any = new Date();
  minResDate: any;
  resDateTimeErrorMessage: any;

  lastInputLength: number = 0;
  callApi: boolean = true;
  previousdateTimeValue: any;
  dateTimeValue: any;
  newDateValue: any;
  newTimeValue: any;

  incidentTypeList: any;
  initalIncidentTypeList: any = [];
  previousincidentTypeValue: any;

  emailRecipients: any;
  slicedUsersCount: any = 4;

  bottomSectionFixedHeight: string = '200 px';
  @ViewChild('resolveTimeTemplate') resolveTimeTemplate: any = TemplateRef<any>;
  promptSendReport: boolean = false;
  displayedEmailRecipients: any;
  showAll: any;
  sortOrder: string = 'desc';

  selectedIncidentTypeList: any = [];
  selectedIncidentTypeIdList: any = [];

  loggedInDeviceID: string = this.deviceInfoService.getUniqueDeviceID();
  webSocketSubscription: any;
  routeSubscription: any;

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private dialogService: ModalDialogueService,
    private dataCheckService: DataCheckService,
    private incidentService: IncidentsService,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private webSocketService: WebSocketService,
    private deviceInfoService: DeviceInfoService,
  ) {
    this.isAdmin = this.dataCheckService.isUserAdmin();
    this.isDispatcher = this.dataCheckService.isDispatchUser();

    this.routeSubscription = this.route.params.subscribe({
      next: (params) => {
        if (params?.['inKey']) {
          this.incidentId = params?.['inKey'];

          this.getIncidentDetail();
        }
      },
    });

    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        const isSameUserOnAnotherDevice =
          this.subscriberUserId === event?.request_user?.subs_id &&
          this.loggedInDeviceID &&
          this.loggedInDeviceID !== event?.request_user?.logged_in_device_id;
        const isAnotherUser =
          this.subscriberUserId !== event?.request_user?.subs_id;

        const allowUser = isSameUserOnAnotherDevice || isAnotherUser;

        if (
          event?.event === 'individual_incident_update' &&
          event?.data?.data?.id === this.detailData?.id &&
          allowUser
        ) {
          // update the changes made by someone else in realtime

          setTimeout(() => {
            this.detailData = event?.data?.data;
            this.formatData(event?.data);
          }, 100);
        }
        if (
          ['user_incident_update'].includes(event?.event) &&
          event?.data?.delete &&
          event?.data?.id === this.detailData?.id &&
          allowUser
        ) {
          // one of the user has deleted the job
          // route to home page.
          this.toasterService.setMessage({
            successMessage: `This incident was just deleted by ${event?.request_user?.user_name}`,
            errorMessage: '',
          });
          this.router.navigate(['/']);
        }
      });
  }
  ngOnDestroy() {
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
    if (this.routeSubscription) this.webSocketSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.userData = this.appService.getUserData();

    this.subscriberUserId = this.userData?.subscriber?.subscriber_user_id;
    this.resolutionDateTime = new Date();
    this.resolutionDay = getFormattedDateTime();
    this.newDateValue = getFormattedDateTime();
    this.resolutionTime = getFormattedTime();
    this.getDeviceID();
  }
  getDeviceID() {
    if (!this.loggedInDeviceID) {
      this.loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();
    }
  }
  getIncidentDetail() {
    this.spinnerService.show();
    this.incidentService
      .retrieveIncident(this.incidentId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  formatData(response: any) {
    this.detailData = response?.data;

    if (
      this.detailData?.status === 0 &&
      this.detailData?.submitted_at &&
      (this.isAdmin || this.isDispatcher)
    ) {
      this.router.navigate(
        ['/review-incident', { inKey: String(this.detailData?.id) }],
        {
          replaceUrl: true,
        },
      );

      return;
    }
    if (!this.detailData?.id) {
      this.router.navigate(['/']);
      return;
    }

    this.incidentHistory = response?.history;
    this.emailRecipients = response?.recipient_emails?.join('<br> ');
    this.emailRecipients = response?.recipient_emails;
    this.updateDisplayedEmailRecipients();

    this.incidentCommentFiles = [
      ...response?.history?.filter((item: any) =>
        //1 = added comment
        //2 = take photo from camera
        //3 = comment changed
        //5 = corrective actions changed
        //7 = incident time changed
        //8 = incident report sent
        //9 = report re-sent
        //10 = incident type changed
        //11 = uploaded photo from device
        [2, 8, 9, 11].includes(item?.event_action),
      ),
    ];
    this.sortedIncidentCommentFiles = [...this.incidentCommentFiles].sort(
      (a, b) =>
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
    );

    this.isCreatedUser = Boolean(
      this.subscriberUserId === this.detailData?.subscriber_user?.id,
    );

    this.isIncidentSubmitted = this.detailData?.submitted_at || false;
    this.spinnerService.hide();
    this.minResDate = new Date(this.detailData?.incident_time);
    this.minResDate.setDate(this.minResDate.getDate() - 1);
    this.ngZone.run(() => {
      setTimeout(() => {
        this.calculateFixedBottomHeight();
        this.spinnerService.hide();
      }, 100);
    });
    this.clearValues();
    this.appService.initializeBootstrapTooltips();
  }
  clearValues() {
    this.newValue = null;
    this.previousTextValue = null;
    this.callApi = true;
    this.lastInputLength = 0;
    this.dialogRef?.close();
  }

  openCommentTemplate(template: TemplateRef<any>, commentData?: any) {
    let dialogContext: any = {};
    if (commentData) {
      this.newValue = commentData?.detail;
      this.previousTextValue = this.newValue;
      dialogContext = commentData;
    }
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: dialogContext,
      },
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value) {
        this.formatData(value);
        this.dialogRef.close();
      }
    });
  }
  openExtraInfoTemplate(template: TemplateRef<any>, extrainfoType?: string) {
    this.newValue =
      extrainfoType == 'ca'
        ? this.detailData?.corrective_actions
        : this.detailData?.information;
    this.previousTextValue = this.newValue;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: { extrainfoType: extrainfoType },
      },
      this.viewContainerRef,
    );
  }
  openHistoryChangeTemplate(template: TemplateRef<any>, data?: any) {
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: data,
      },
      this.viewContainerRef,
    );
  }
  openupdateIncidentTimeTemplate(template: TemplateRef<any>) {
    this.previousdateTimeValue = this.newDateValue;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  openPromptSendReport() {
    let dialogMsg = '';
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Submit Incident Report',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.dialogService.open(
          this.resolveTimeTemplate,
          {},
          this.viewContainerRef,
        );
      }
    });
  }
  openupdateIncidentTypeTemplate(template: TemplateRef<any>) {
    this.selectedIncidentTypeList = JSON.parse(
      JSON.stringify(this.detailData?.incident_types || []),
    );
    if (!this.selectedIncidentTypeList?.length) {
      this.selectedIncidentTypeList.push({ isFocused: true });
    }
    this.getIncidentTypes();

    this.previousincidentTypeValue = this.detailData?.incident_type;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  onSelectIncidentType(event: any, index: number) {
    if (event?.key === 0) {
      this.onAddIncidentType(index);
    }
    if (event?.id) {
      this.selectedIncidentTypeList[index] = {
        ...event,
        isFocused: false,
      };
      this.getIncidentTypeIdList();
    }
  }

  onAddIncidentType(index: number) {
    if (this.previousincidentTypeValue.length > 0) {
      this.spinnerService.show();
      var requestData = { name: this.previousincidentTypeValue };
      this.incidentService
        .createIncidentType(requestData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: '',
              successMessage: response['message'],
            });
            this.previousincidentTypeValue = '';
            this.onSelectIncidentType(response?.data, index);
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Incident Name can't be empty",
        successMessage: '',
      });
    }
  }
  mapsSelector(lat: any, lon: any) {
    if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf('iPhone') != -1 ||
      navigator.platform.indexOf('iPad') != -1 ||
      navigator.platform.indexOf('iPod') != -1
    )
      window.open(`maps://maps.google.com/maps?daddr=${lat},${lon}&amp;ll=`);
    /* else use Google */ else
      window.open(`https://maps.google.com/maps?daddr=${lat},${lon}&amp;ll=`);
  }
  editComment(data?: any) {
    if (!data?.id && !this.newValue?.trim()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Comment cannot be empty',
      });
      return;
    }
    this.spinnerService.show();
    let body: any = {
      incident_id: this.detailData?.id,
      comment: this.newValue,
    };
    if (Object.keys(data).length) {
      body.id = data?.id;
      body.edit_comment = 1;
    }
    if (body) {
      this.updateIncident(body);
    }
  }
  updateIncident(body: any, params?: any) {
    this.spinnerService.show();
    this.incidentService.updateIncident(body, params).then((response: any) => {
      if (response?.status == 'success') {
        if (response?.data) {
          this.detailData = response['data'];

          // if (this.promptSendReport && this.selectedUsers?.length) {
          //   this.promptSendReport = false;
          //   this.openPromptSendReport();
          // }
          if (this.promptSendReport) {
            this.promptSendReport = false;
            this.openPromptSendReport();
          }
          this.formatData(response);

          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
        }
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }

      this.spinnerService.hide();
    });
  }

  updateIncidentDetails(body: any, params?: any) {
    this.spinnerService.show();
    this.incidentService
      .updateIncidentDetails(body, params)
      .then((response: any) => {
        if (response?.status == 'success') {
          if (response?.data) {
            this.detailData = response['data'];

            if (this.promptSendReport) {
              this.promptSendReport = false;
              this.openPromptSendReport();
            }
            // this.openPromptSendReport();
            this.formatData(response);

            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  openCamPopup() {
    this.dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'updateIncident' },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.onFileSubmit(value);
      } else if (value == 'error') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'ERROR: Unable to access your camera',
        });
      }
    });
  }

  //Method to upload the photo
  onFileSubmit(imageData: any) {
    if (!imageData?.actualFileUpload) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'ERROR: Please add a photo',
      });
    } else {
      this.spinnerService.show('Uploading - Please Wait');
      let fileData: FormData = new FormData();

      fileData.append('file', imageData?.actualFileUpload);
      if (imageData?.newComment) {
        fileData.append('comment', imageData?.newComment);
      }
      let url = `incident/update_incident`;
      fileData.append('incident_id', this.detailData?.id);
      fileData.append('image_source', imageData?.uploadType);
      if (imageData?.exifData && Object.values(imageData?.exifData)?.length) {
        fileData.append('exif_data', JSON.stringify(imageData?.exifData));
      }

      this.appService.formDataApi(url, fileData).then((response: any) => {
        if (response?.data) {
          this.formatData(response);
        }

        this.spinnerService.hide();
      });
    }
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogRef = this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  redirectToClientPage() {
    this.router.navigate([
      '/view-client',
      { cKey: String(this.detailData?.company?.id) },
    ]);
  }

  updateExtraInfo(infoData: any) {
    let body: any = { incident_id: this.detailData?.id };
    body[
      infoData?.extrainfoType == 'ca' ? 'corrective_actions' : 'information'
    ] = this.newValue;
    if (body) {
      this.promptSendReport = Boolean(infoData?.extrainfoType == 'ca');

      this.updateIncidentDetails(body);
    }
  }
  updateincidentTime(infoData: any) {
    let body: any = { incident_id: this.detailData?.id };
    let dateTimeString = new Date(this.newDateValue);
    body['incident_time'] = dateTimeString;
    if (body) {
      this.updateIncidentDetails(body);
    }
  }

  getIncidentTypes(params?: any) {
    this.incidentService.fetchIncidentTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.incidentTypeList = res['data'];
        this.initalIncidentTypeList = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  onSearchIncidentType(event: any) {
    this.previousincidentTypeValue = event.target.value;
    if (event.target.value.length) {
      this.incidentTypeList = this.initalIncidentTypeList?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.incidentTypeList = this.initalIncidentTypeList;
    }
  }

  submitIncident() {
    this.spinnerService.show();
    // let markedUSers = this.selectedUsers?.filter(
    //   (user: any) => !user?.isSnubbed,
    // );

    let body: any = {
      incident_id: this.detailData?.id,
      // user_ids: [...new Set([...markedUSers].map((item) => item.pk))],
    };
    if (this.isIncidentSubmitted) {
      body.resend_report = true;
    } else {
      let dateTime = new Date(this.resolutionDateTime);
      body.resolution_time = dateTime;
      body.log_incident = true;
    }

    this.updateIncidentDetails(body);
  }
  formateStartDate(event: any) {
    this.resolutionDay = event.target.value;
    this.resolutionDateTime = event.target.value;
  }

  markResolved(template: TemplateRef<any>) {
    this.dialogService.open(template, {}, this.viewContainerRef);
  }
  reOpenReport() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: '',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let body: any = {
          incident_id: this.detailData?.id,
          reopen_incident: 1,
        };

        this.updateIncidentDetails(body);
      }
    });
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.click();

      element?.focus();
    });
  }

  deleteRestoreUserUpdate(event: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: event?.type === 'delete' ? 'Delete Event' : 'Restore Event',
        message:
          event?.type === 'delete'
            ? `Are you sure you want to delete this event?`
            : 'Are you sure you want to restore this event?',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let body: any = {
          id: event?.event?.id,
          incident_id: this.detailData?.id,
        };
        body[event?.type === 'delete' ? 'delete_update' : 'restore_update'] = 1;

        this.updateIncident(body);
      }
    });
  }

  formateNewStartDate(event: any) {
    this.newDateValue = event.target.value;
  }
  formatNewStartTime(event: any) {
    var [hours, minutes] = event.target.value.split(':');
    let startDateTime = new Date(this.dateTimeValue);
    startDateTime.setHours(parseInt(hours));
    startDateTime.setMinutes(parseInt(minutes));

    if (startDateTime.getTime() > new Date().getTime()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'cannot set future date',
      });
    } else {
      this.newTimeValue = event.target.value;
      this.dateTimeValue = startDateTime;
    }
  }
  deleteIncident() {
    let dialogMsg = 'Delete Incident?';
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Confirmation Needed',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.spinnerService.show();
        this.incidentService
          .deleteIncident(this.detailData?.id)
          .subscribe((response: any) => {
            if (response?.status == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              this.router.navigate(['/incidents']);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }

            this.spinnerService.hide();
          });
      }
    });
  }

  hasUnsnubbedUsers(): boolean {
    return true;
    // return this.selectedUsers.some((user: any) => !user.isSnubbed);
  }
  calculateFixedBottomHeight() {
    // Get the bottom-section-fixed element by ID

    const bottomSectionFixed = document.getElementById('fixedBtn');

    if (bottomSectionFixed) {
      this.bottomSectionFixedHeight =
        bottomSectionFixed.offsetHeight.toString() + 'px';
    }
  }
  toggleSortOrder() {
    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    this.sortUpdates();
  }
  sortUpdates(event?: any) {
    if (this.sortOrder === 'asc') {
      this.sortedIncidentCommentFiles = [...this.incidentCommentFiles].sort(
        (a, b) =>
          new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime(),
      );
    } else {
      this.sortedIncidentCommentFiles = [...this.incidentCommentFiles].sort(
        (a, b) =>
          new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
      );
    }
  }

  updateDisplayedEmailRecipients() {
    this.displayedEmailRecipients = this.showAll
      ? this.emailRecipients.join('<br>')
      : this.emailRecipients.slice(0, 5).join('<br>');
  }
  toggleShowAll() {
    this.showAll = !this.showAll;
    this.updateDisplayedEmailRecipients();
  }
  openSiteView(siteData: any) {
    this.router.navigate(['/view-site', { sKey: String(siteData?.id) }]);
  }
  clearAndFocusTextBox(elementId: string) {
    this.newValue = '';
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  addNewSiteKeyField() {
    this.selectedIncidentTypeList = this.selectedIncidentTypeList?.filter(
      (element: any) => element?.id,
    );
    this.selectedIncidentTypeList.forEach(
      (element: any) => (element.isFocused = false),
    );
    this.selectedIncidentTypeList.push({ isFocused: true });
    this.incidentTypeList = JSON.parse(
      JSON.stringify(this.initalIncidentTypeList || []),
    );
    this.incidentTypeList = this.incidentTypeList?.filter(
      (iType: any) =>
        !this.selectedIncidentTypeList?.some(
          (selectedIType: any) => selectedIType?.id == iType?.id,
        ),
    );
    this.shiftFocus('iTypeLookupField');
    this.getIncidentTypeIdList();
  }
  deleteSiteKeyField(index: number) {
    this.selectedIncidentTypeList.splice(index, 1);
    if (!this.selectedIncidentTypeList?.length) {
      this.selectedIncidentTypeList.push({ isFocused: true });
      this.shiftFocus('iTypeLookupField');
    }
    this.getIncidentTypeIdList();
  }
  openIncidentTypeLookup(index: number) {
    this.selectedIncidentTypeList[index] = {
      isFocused: true,
    };
    this.shiftFocus('iTypeLookupField');
    this.incidentTypeList = JSON.parse(
      JSON.stringify(this.initalIncidentTypeList || []),
    );
    this.incidentTypeList = this.incidentTypeList?.filter(
      (iType: any) =>
        !this.selectedIncidentTypeList?.some(
          (selectedIType: any) => selectedIType?.id == iType?.id,
        ),
    );
    this.getIncidentTypeIdList();
  }
  getIncidentTypeIdList() {
    const listWithIds = this.selectedIncidentTypeList?.filter(
      (iType: any) => iType?.id,
    );
    this.selectedIncidentTypeIdList = [
      ...new Set(listWithIds?.map((iType: any) => iType?.id)),
    ];
  }
  updateIncidentTypeList() {
    const listWithIds = this.selectedIncidentTypeList?.filter(
      (iType: any) => iType?.id,
    );
    this.selectedIncidentTypeIdList = [
      ...new Set(listWithIds?.map((iType: any) => iType?.id)),
    ];
    this.updateIncidentDetails({
      incident_types: this.selectedIncidentTypeIdList,
      incident_id: this.detailData?.id,
    });
  }
  checkAndAddIncidentType(index: number) {
    if (
      this.previousincidentTypeValue?.length > 0 &&
      !this.incidentTypeList?.length
    ) {
      this.onAddIncidentType(index);
    }
  }
}
